import React from 'react';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import MapSelectorView from '../../Maps/MapSelectorView.jsx';

class MapSelectionField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSelecting: false
    };
  }

  onValueChange = (value) => {
    const { input } = this.props;
    if (input) {
      input.onChange(value);
    }
  };

  render() {
    const { input, meta, title, subtitle, disabled } = this.props;
    return (
      <div>
        {title && (
          <label className="control-label">
            <Entity entity={title} />
          </label>
        )}
        {subtitle && (
          <label className="control-label">
            <Entity entity={subtitle} />
          </label>
        )}
        <MapSelectorView
          value={input.value}
          onChange={this.onValueChange}
          disabled={disabled}
        />
        {meta.touched && meta.error && (
          <div className="help-block">
            <Entity entity={meta.error} />
          </div>
        )}
      </div>
    );
  }
}

export default MapSelectionField; 